import { useEffect } from 'react';

const NOINDEX_CONTENT = 'noindex, nofollow';
const META_NAMES = ['robots', 'googlebot'] as const;

/** Sets robots/googlebot meta to noindex while the component is mounted, restoring previous values on unmount. */
export function useNoIndex() {
  useEffect(() => {
    const snapshots: { el: HTMLMetaElement; previousContent: string | null; created: boolean }[] = [];

    for (const name of META_NAMES) {
      let el = document.querySelector<HTMLMetaElement>(`meta[name="${name}"]`);
      const created = !el;
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute('name', name);
        document.head.appendChild(el);
      }
      const previousContent = el.getAttribute('content');
      el.setAttribute('content', NOINDEX_CONTENT);
      snapshots.push({ el, previousContent, created });
    }

    return () => {
      for (const { el, previousContent, created } of snapshots) {
        if (created) {
          el.remove();
        } else if (previousContent !== null) {
          el.setAttribute('content', previousContent);
        } else {
          el.removeAttribute('content');
        }
      }
    };
  }, []);
}
